import React from 'react';
import PropTypes from 'prop-types';

import { createStyles, TableCell, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const styles = (_theme: Theme) =>
  createStyles({
    tableCellBorder: {
      borderColor: 'rgba(0,0,0,.12)',
      borderWidth: '0 0 1px 1px',
      borderCollapse: 'separate',
      borderLeftStyle: 'solid',
      borderBottomStyle: 'solid',
    },
  });

const useStyles = makeStyles(styles);

interface NkNoRecordsTableCellProps {
  columnCount?: number;
  noRecordsAvailableLabel?: string;
}

const NkNoRecordsTableCell = (props: NkNoRecordsTableCellProps) => {
  const classes = useStyles();

  return (
    <TableCell
      className={classes.tableCellBorder}
      colSpan={props.columnCount}
      style={{ textAlign: 'center' }}
    >
      {props.noRecordsAvailableLabel}
    </TableCell>
  );
};

NkNoRecordsTableCell.propTypes = {
  columnCount: PropTypes.number,
  noRecordsAvailableLabel: PropTypes.string,
};

export default NkNoRecordsTableCell;
